import React from 'react';
import { GridLegacy as Grid, Button } from '@mui/material';
import { BackButton } from '@monorepo/react/material-buttons';

interface FormActionProps {
  submitButtonLabel?: string;
  backButtonLabel?: string;
  isSubmitting: boolean;
  isDirty: boolean;
  onSubmitClick?: () => unknown;
  actions?: React.ReactNode;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
  children?: React.ReactNode;
}

type SubmitActionProps = Pick<
  FormActionProps,
  'actions' | 'isDirty' | 'isSubmitting' | 'onSubmitClick' | 'submitButtonLabel'
> & {
  buttonColor: NonNullable<FormActionProps['color']>;
};

const SubmitAction: React.FC<SubmitActionProps> = ({
  actions,
  buttonColor,
  isDirty,
  isSubmitting,
  onSubmitClick,
  submitButtonLabel,
}) => (
  <Grid
    item
    xs={12}
    md={actions ? 12 : 7}
    lg={actions ? 7 : 5}
    xl={actions ? 6 : 4}
  >
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
      }}
    >
      <Button
        onClick={() => onSubmitClick && onSubmitClick()}
        fullWidth={!actions}
        type="submit"
        variant="contained"
        color={buttonColor}
        disabled={isSubmitting || !isDirty}
        style={actions ? { flex: '1 1 240px' } : undefined}
      >
        {submitButtonLabel}
      </Button>
      {actions}
    </div>
  </Grid>
);

export const FormActions: React.FC<FormActionProps> = ({
  submitButtonLabel,
  backButtonLabel,
  isSubmitting,
  isDirty,
  onSubmitClick,
  actions,
  children,
  color,
}) => {
  const buttonColor = color ? color : 'primary';
  return (
    <>
      {submitButtonLabel && (
        <SubmitAction
          actions={actions}
          buttonColor={buttonColor}
          isDirty={isDirty}
          isSubmitting={isSubmitting}
          onSubmitClick={onSubmitClick}
          submitButtonLabel={submitButtonLabel}
        />
      )}

      {backButtonLabel && (
        <Grid item xs={12} md={5} lg={4}>
          <BackButton fullWidth text={backButtonLabel} />
        </Grid>
      )}
      {children}
    </>
  );
};
